t = require('views/internal/teacup-with-helpers')('org_remove_or_deactivate_member')

module.exports = ->
  t.ul '.pop-over-list', ->

    t.li '.u-clearfix', ->
      t.a '.js-soft-remove', { href: '#' }, ->
        t.span '.u-clearfix', ->
          t.mustacheBlock 'isMe', ->
            t.format 'leave-organization'
          t.mustacheBlockInverted 'isMe', ->
            t.format 'remove-from-organization'

        t.span '.sub-name', ->
          t.mustacheBlock 'isDeactivated', ->
            t.format 'remove-all-access-to-the-organization-and-all-boards'
          t.mustacheBlockInverted 'isDeactivated', ->
            t.mustacheBlock 'orgIsBC', ->
              t.format 'remove-all-access-to-the-organization'
            t.mustacheBlockInverted 'orgIsBC', ->
              t.format 'remove-all-access-to-the-organization-the-member-will-remain-on-all-their-boards-in-this-organization-they-will-receive-a-notification'

      t.mustacheBlock 'orgIsBC', ->
        t.mustacheBlockInverted 'isDeactivated', ->
          t.mustacheBlockInverted 'isMe', ->
            t.span '.check-div.quiet.u-clearfix', { style: 'margin-left: 24px; padding-top: 2px; font-size: 12px; line-height: 15px;' }, ->
              t.input { type: 'checkbox', id: 'hardRemove', name: 'hard', checked: true }
              t.label { for: 'hardRemove' }, ->
                t.format 'check-this-box-to-remove-the-member-from-all-boards'

    t.mustacheBlock 'canDeactivate', ->
      t.mustacheBlockInverted 'isMe', ->
        t.li '.u-clearfix', ->
          t.a '.js-deactivate', { href: '#' }, ->
            t.format 'deactivate-disable-members-access-to-organization-boards-but-allow-other-organization-members-to-see-what-the-cards-and-boards-the-member-was-on'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_remove_or_deactivate_member.coffee